export const isRestrictedPathSegment = (segment) =>
  [
    'additionalItems',
    'allOf',
    'anyOf',
    'contains',
    'definitions',
    'else',
    'if',
    'items',
    'not',
    'oneOf',
    'patternProperties',
    'propertyNames',
    'then',
  ].includes(segment);

export const hasRestrictedPathSegment = (segments) => segments.some(isRestrictedPathSegment);
